import { Component, OnInit } from '@angular/core';
import { CentroCusto } from '../../../../types/CentroCusto.type';
import { CentrodecustosService } from './centrodecustos.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-centrodecustos',
  templateUrl: './centrodecustos.component.html',
  styleUrl: './centrodecustos.component.css'
})
export class CentrodecustosComponent implements OnInit {

  centrocustos: CentroCusto[] = []
  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private centroService: CentrodecustosService, private toastService: ToastService) { }


  ngOnInit() {

    this.getAll()

  }

  getAll() {
    this.loading = true;

    this.centroService.getCentroCustos().subscribe({
      next: (data) => {
        this.centrocustos = data;
        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro("Erro ao buscar", error);
        this.loading = false;
      }
    })
  }


  exportar() {

    this.loadingSincronizar = true;

    this.centroService.exportar().subscribe({
      next: (value) => {
        const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'centroCustos.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      },
      error: (error) => {
        this.toastService.erro("Exportar", `Erro ao exportar: ${error.error}`);
        this.loadingSincronizar = false;
      },
      complete: () => {
        this.loadingSincronizar = false;
      }
    })
  }

}
